import { Expose } from 'class-transformer';

export class RegisterModel {
  public id? = null;
  public password = '';
  @Expose({ name: 'password_repeat' })
  public passwordRepeat = '';
  @Expose({ name: 'first_name' })
  public firstName = '';
  @Expose({ name: 'last_name' })
  public lastName = '';
  public email = '';
}
